function renderServiceBlocks(editor, indexProject) {
    const tempData = JSON.parse(localStorage.getItem('data'));
  
    tempData.forEach((servicesPerProject) => {
      servicesPerProject.services.forEach((service) => {
        service.services_blocks.forEach((block) => {
          if (editor.BlockManager !== undefined) {
            editor.BlockManager.remove(block.id);
          }
        });
      });
    });
  
    tempData.forEach((servicesPerProject, index) => {
      if (index === parseInt(indexProject, 10)) {
        servicesPerProject.services.forEach((service) => {
          service.services_blocks.forEach((block) => {
            if (editor.BlockManager !== undefined) {
              editor.BlockManager.add(block.id, {
                label: block.label,
                content: block.content,
                category: block.category
              });
            }
          });
        });
      }
    });
  }
  
function renderDataElementsBlocks(editor, indexProject) {
    if (editor.BlockManager !== undefined) {
        const tempData = JSON.parse(localStorage.getItem('data'));

        tempData.forEach((dataPerProject) => {
        dataPerProject.data_elements.data_elements_blocks.forEach((dataElementBlocks) => {
            dataElementBlocks.blocks.forEach((dataElementBlock) => {
            editor.BlockManager.remove(dataElementBlock.id);
            });
        });
        });
        tempData.forEach((dataPerProject, index) => {
        if (index === parseInt(indexProject, 10)) {
            dataPerProject.data_elements.data_elements_blocks.forEach((dataElementBlocks) => {
            dataElementBlocks.blocks.forEach((dataElementBlock) => {
                editor.BlockManager.add(dataElementBlock.id, {
                label: dataElementBlock.label,
                content: dataElementBlock.content,
                category: dataElementBlock.category
                });
            });
            });
        }
        });
    }
}

const extractCss = (customBlockStyle) => {
  
  let style = `<style>`;
  
  customBlockStyle.forEach( blockStyle => {
    let classRule = ` `;
    blockStyle.selectors.forEach( selector => {
      classRule += `.${selector}`;
    })

    let contentClassRule = ``;
    Object.keys(blockStyle.style).forEach( key =>{
      contentClassRule += `${key}: ${blockStyle.style[key]};\n`
    })

    style += `\n ${classRule}{\n ${contentClassRule}}`

  })

  return `${style}</style>`
}

function renderCustomBlocks(editor,indexProject){
  if (editor.BlockManager !== undefined) {
    const tempData = JSON.parse(localStorage.getItem('data'));

    tempData.forEach((dataPerProject) => {
        dataPerProject.customBlocks.forEach((customBlock) => {
            editor.BlockManager.remove(customBlock.content.id);
        });
    });
    tempData.forEach((dataPerProject, index) => {
      if (index === parseInt(indexProject, 10) ) {
          dataPerProject.customBlocks.forEach((customBlock) => {
                        
            editor.BlockManager.add(customBlock.content.id,{
              label: customBlock.content.label,
              content: customBlock.content.content+extractCss(customBlock.style),
              category: {
                label: 'Extra ',
                open: 'true',
              },
              attributes:{
                customBlock: true
              }
            })
          });
      }
    });
  }
}

export {
    renderServiceBlocks,
    renderDataElementsBlocks,
    renderCustomBlocks,
    extractCss
}
